var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.pageDataFetched
    ? _c(
        "div",
        { attrs: { id: "update-payment-page" } },
        [
          _c("checkout-header", {
            attrs: {
              categoryFilter: { display: false },
              shoppingBag: { display: false },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "body" } },
            [
              _c("h3", [
                _vm._v(_vm._s(_vm.checkoutSharedContent.paymentDetails)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "black bold" }, [
                _c("span", { staticClass: "icon small inline lock" }),
                _vm._v(" " + _vm._s(_vm.checkoutSharedContent.sslEncryption)),
              ]),
              _vm._v(" "),
              _c("h5", { staticClass: "margin-top-20" }, [
                _vm._v(_vm._s(_vm.checkoutSharedContent.selectPaymentMethod)),
              ]),
              _vm._v(" "),
              _c("payment-method", {
                attrs: { availablePaymentMethods: _vm.availablePaymentMethods },
              }),
              _vm._v(" "),
              _c("submit-button", {
                attrs: {
                  position: "center",
                  mobile: "12",
                  tablet: "3",
                  desktop: "3",
                  styling: "primary",
                },
                on: { onClickEvent: _vm.submitUpdatePaymentData },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.checkoutSharedContent.continue) +
                              "\n      "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1595525758
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }